<template>
  <div class='login-container'>
    <div class="login-box">
      <el-tabs v-model="activeName" type="card">
        <!--        <el-tab-pane label="微信登录" name="first">
          <div id="wxContainer"></div>
        </el-tab-pane> -->
        <el-tab-pane label="账号密码" name="second">
          <el-form class="login-form">
            <!--      <div style="margin-left: 5px;font-size: 21px;">{{appName}}</div>
      <div style="margin-left: 5px;font-size: 21px;">{{subName}}</div> -->
            <el-form-item class="login-form-item">
              <el-input v-model="username" type="text" @blur="handleInputConfirm" placeholder="请输入用户名"
                style="width: 300px">
                <el-button slot="prepend" icon="el-icon-user"></el-button>
              </el-input>
            </el-form-item>
            <el-form-item class="login-form-item">
              <el-input v-model="password" type="password" placeholder="请输入密码" style="width: 300px"
                @keyup.enter.native="login">
                <el-button slot="prepend" icon="el-icon-lock"></el-button>
              </el-input>
            </el-form-item>
            <div>
              <!-- <el-button type="primary" style="width: 300px" @click="login" :disabled="disabledLogin">登录</el-button> -->
              <el-button type="primary" style="width: 300px" @click="login" :disabled="disabledLogin">登录</el-button>
            </div>

            <!--      <div style="margin-top: 20px;">
        <el-link type="primary" @click="forgetPassowrd">忘记密码</el-link>
        <el-link type="primary" @click="regist">免费试用</el-link>
      </div>
 -->

          </el-form>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
  import axios from '@/axios'
  import {
    DecryptCBC,
    EncryptCBC,
    DecryptECB,
    EncryptECB,
    getUUID
  } from '@/axios/crypto.js'

  import {
    mapState
  } from 'vuex'

  export default {
    computed: {
      ...mapState({
        appName: state => state.app.appName,
        appCode: state => state.app.appCode,
        subName: state => state.app.subName,
      })
    },
    data() {
      return {
        activeName: 'second',

        username: '',
        password: '',
        userDesc: '',
        disabledLogin: true,
      }
    },
    mounted() {
      // var href =
      //   'data:text/css;base64,LmltcG93ZXJCb3ggLnFyY29kZSB7d2lkdGg6IDIwMHB4O30KLmltcG93ZXJCb3ggLnRpdGxlIHtkaXNwbGF5OiBub25lO30KLmltcG93ZXJCb3ggLmluZm8ge3dpZHRoOiAyMDBweDt9Ci5pbXBvd2VyQm94IC5zdGF0dXMge3RleHQtYWxpZ246IGNlbnRlcjt9IA=='

      // var obj = new WxLogin({
      //   self_redirect: false,
      //   id: "wxContainer",
      //   appid: "wxdfad3607db309ff5",
      //   scope: "snsapi_login",
      //   redirect_uri: encodeURIComponent("http://www.yuanxisoft.com/#/login"),
      //   state: Math.random(),
      //   style: "black",
      //   href: href
      // });
      // console.log(obj)
    },
    methods: {
      loginByScan(code) {
        // const loading = this.$loading({
        //   lock: true,
        //   text: '正在登录请稍后···',
        //   spinner: 'el-icon-loading',
        //   background: 'rgba(0, 0, 0, 0.7)'
        // });

        var url = 'wx/Login/LoginByScan.do'
        var param = {
          openId: localStorage.getItem('openId'),
          code: code,
          app: this.appCode,
        }
        axios.post(url, param).then(response => {
          if (response.data.code == '0') {
            this.$store.commit('setMenuLoaded', false)
            this.$store.commit('setRouteLoaded', false)
            localStorage.setItem('userId', response.data.data.userId)
            localStorage.setItem('openId', response.data.data.openId)
            localStorage.setItem('unionId', response.data.data.unionId)
            localStorage.setItem('userName', response.data.data.userName)
            localStorage.setItem('token', response.data.data.token)
            this.$router.push('/home/main')
          } else {
            this.$message({
              type: 'error',
              message: '操作失败！' + response.data.msg,
            });
          }

        });

      },
      login() {
        const loading = this.$loading({
          lock: true,
          text: '正在登录请稍后···',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });

        var url = 'framework/SysLogin/login.do'
        var param = {
          username: this.username,
          password: this.password
        }
        axios.post(url, param).then(response => {
          if (response.data.code == '0') {
            this.$store.commit('setMenuLoaded', false)
            this.$store.commit('setRouteLoaded', false)
            localStorage.setItem('userId', response.data.data.id)
            localStorage.setItem('token', response.data.data.token)
            localStorage.setItem('belongId', response.data.data.belongId)
            this.$router.push('/home/main')
          } else {
            this.$message({
              type: 'error',
              message: '操作失败！' + response.data.msg,
            });
          }
          if (response) {
            loading.close();
          }
        });
      },
      handleInputConfirm() {
        //this.username = this.username.toUpperCase()
        var url = 'framework/SysLogin/getUserDesc.do'
        var param = {
          username: this.username
        }
        axios.post(url, param).then(response => {
          if (response.data.code == '0') {
            if (response.data.data == '') {
              this.userDesc = "无此用户"
            } else {
              this.userDesc = response.data.data
            }
          } else {
            this.userDesc = "获取用户异常"
          }

        });
      },
      setRe(loginRemember, loginRememberUsername, loginRememberPassword) {

      },
      getPublicKey() {
        var url = 'framework/SysLogin/queryPublicKey.do'
        var param = {}
        axios.post(url, param).then(response => {
          if (response.data.code == '0') {
            localStorage.setItem('publicKey', response.data.data)
            // console.log('publicKey:' + response.data.data)
            this.disabledLogin = false
          } else {
            this.disabledLogin = true
          }

        });
      },
      error(error) {
        console.log('login err::' + error)
        this.$alert(error, '异常', {
          confirmButtonText: '确定',
          callback: action => {}
        });
      },

      regist() {
        this.$router.push('/regist')
      },
      forgetPassowrd() {

      }
    },
    created() {
      this.getPublicKey()
      var loginRemember = localStorage.getItem('loginRemember')
      var loginRememberUsername = localStorage.getItem('loginRememberUsername')
      var loginRememberPassword = localStorage.getItem('loginRememberPassword')
      if (loginRemember == 'true') {
        this.rememberChecked = true
        this.username = loginRememberUsername
        this.password = loginRememberPassword
      } else {
        this.rememberChecked = false
        this.username = loginRememberUsername
        this.password = loginRememberPassword
      }

    },
    beforeRouteEnter(to, from, next) {
      if (to.query.error != null && to.query.error != '') {
        next(vm => {
          vm.error(to.query.error)
        })
      } else if (to.query.code != null && to.query.code != '') {
        console.log('to.query.code' + to.query.code)
        next(vm => {
          vm.loginByScan(to.query.code)
        })
      } else {
        next()
      }
    },


  }
</script>
<style>
  .login-container {
    height: 100%;
    width: 100%;
    margin: 0px 0px 0px 0px;
    background: url(../../../../static/login.jpg) no-repeat;
    /* background: url(../../../assets/img/background2.png) no-repeat; */
    background-size: 100% 100%;
  }

  .login-box {
    /* padding-top: 20px; */
    text-align: center;
    background: #FFFFFF;
    width: 400px;
    height: 350px;
    overflow: hidden;
    position: absolute;
    top: 32%;
    right: 15%;
    border-radius: 10px;
    /* 		position: absolute;
 	padding-top: 22%;
 	padding-left: 40%; */
  }


  .login-form {
    padding-top: 50px;
    text-align: center;
    background: #FFFFFF;
    border-radius: 10px;
    /* 		position: absolute;
 	padding-top: 22%;
 	padding-left: 40%; */
  }

  .login-form-item {
    margin-top: 15px;
  }

  .login-img {
    width: 70px;
    padding-left: 0;
    vertical-align: middle;
    display: inline-block;
    float: none;
  }
</style>



// WEBPACK FOOTER //
// src/view/framework/login/login.vue